import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-dialog-csv',
  templateUrl: './dialog-csv.component.html',
  styleUrls: ['./dialog-csv.component.scss']
})
export class DialogCsvComponent implements OnInit {
  select_part_columns: FormControl = new FormControl('true');
  selected_channels_count: number = 0;

  countries: FormControl = new FormControl(false);

  constructor(public dialogRef: MatDialogRef<DialogCsvComponent>, 
  @Inject(MAT_DIALOG_DATA) public data: { selected_channels_count: number; countries: boolean }) {
    this.selected_channels_count = data.selected_channels_count;
  }

  ngOnInit() {
  }

  export() {
    let _return = {select_part_columns: this.select_part_columns.value};
    if (this.countries.value) _return['countries'] = true;
    this.dialogRef.close(_return);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-csv/dialog-csv.component.ts